import React, { useEffect, useState } from 'react';
import { Container, Jumbotron, Col, Row, Spinner } from 'react-bootstrap';
import { LectureCard } from '../Components/LectureCard';

import Axios from 'axios';
import { useParams } from 'react-router';
export const ExtraClass = () => {
  const [content, setContent] = useState([]);
  const { role } = useParams();
  const getContent = () => {
    try {
      Axios({
        url: '/.netlify/functions/fetchContent',
        params: {
          subject: 'Extra Class',
          cr: role,
        },
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(localStorage.getItem('gotrue.user')).token.access_token,
          credentials: 'include',
        },
      })
        .then((response) => {
          setContent(response.data.items);
        })
        .catch(console.error);
    } catch {
      window.location.href = '/';
    }
  };
  useEffect(getContent, [role]);
  function getId(url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11
      ? 'https://www.youtube.com/embed/' + match[2]
      : null;
  }
  return (
    <Container className='py-4'>
      <Jumbotron className='rounded bg-custom-3' fluid style={{ padding: 20 }}>
        <Container>
          <h1 className='text-center'>Extra Class</h1>
          <p className='text-center'>
            This is the extra classroom here you can find uploaded lectures
          </p>
        </Container>
      </Jumbotron>
      <Row>
        {content ? (
          content.map((elem, index) => {
            return (
              <Col md={6}>
                <LectureCard
                  name={elem.name}
                  videourl={getId(elem.videoUrl)}
                  attachedDocument={elem.attachedDocument}
                  sys={elem.sys}
                  driveLink={
                    elem.hasOwnProperty('driveLink') ? elem.driveLink : ''
                  }
                />
              </Col>
            );
          })
        ) : (
          <Spinner className='text-center' animation='border'></Spinner>
        )}
      </Row>
    </Container>
  );
};
